import axios from 'axios';
import {
	FETCH_POSTOFFICES_FAILED,
	FETCH_POSTOFFICES_FULFILLED,
	FETCH_POSTOFFICES_PENDING,
} from '../constants/actions/postOfficeActions';
import { POSTOFFICES } from '../constants/paths/api';

export const fetchPostOfficesPending = () => ({
	type: FETCH_POSTOFFICES_PENDING,
	payload: null,
});

export const fetchPostOfficesFulfilled = postOffices => ({
	type: FETCH_POSTOFFICES_FULFILLED,
	payload: {
		postOffices,
	},
});

export const fetchPostOfficesFailed = error => ({
	type: FETCH_POSTOFFICES_FAILED,
	payload: {
		error,
	},
});

export const fetchPostOffices = (language = 'IS') => {
	language = language === 'is' ? 'IS' : language;

	return async dispatch => {
		dispatch(fetchPostOfficesPending());

		try {
			const response = await axios(`${POSTOFFICES}?language=${language}`);
			dispatch(fetchPostOfficesFulfilled(response.data));
		} catch (error) {
			dispatch(fetchPostOfficesFailed(error));
		}
	};
};
